import { createApp } from 'vue'
import Loading from '@/components/Loading/index.vue'
import { loadingService } from '@/utils/loadingService'

let loadingInstance = null

export default {
  install: (app) => {
    // 将loadingService的方法添加到全局属性
    app.config.globalProperties.$loading = {
      show(text = 'loading...') {
        loadingService.show(text)
        
        // 如果组件还没挂载，需要创建并挂载
        if (!loadingInstance) {
          // 创建载体div
          const container = document.createElement('div')
          document.body.appendChild(container)
          
          // 创建实例
          const instance = createApp(Loading)
          
          // 挂载
          loadingInstance = {
            instance,
            component: instance.mount(container)
          }
        }
      },
      
      hide() {
        loadingService.hide()
      }
    }
  }
}

// 导出loadingService以便在其他文件使用
export { loadingService } 